var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
export var Component = function (p) {
    return (Preact.h(Box, { sx: __assign({ boxSizing: 'border-box', height: '44px', width: '100%', display: 'flex', padding: '8px', justifyContent: 'flex-end', alignItems: 'center' }, p.sx) },
        Preact.h(IconButton, { onClick: p.onCloseClick, size: "small", color: "secondary", disabled: p.disabled },
            Preact.h(CloseIcon, { fontSize: "small" }))));
};
Component.displayName = 'CloseBar';
